export default "__VITE_ASSET__BvyXkwpp__"